import { Navigate, Outlet, Link, useLocation } from "react-router-dom";
import { useAdminAuth } from "@/admin/AdminAuthContext";
import { Loader2, LogOut, FileText, Newspaper, Layers, Download } from "lucide-react";

export default function AdminLayout() {
  const { user, logout } = useAdminAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div className="min-h-screen grid place-items-center bg-paper text-navy">
        <Loader2 className="animate-spin" />
      </div>
    );
  }
  if (user === false) {
    return <Navigate to="/admin/login" replace state={{ from: location }} />;
  }

  const links = [
    { to: "/admin", label: "الرئيسية", icon: null, exact: true },
    { to: "/admin/publications", label: "الإصدارات المعرفية", icon: FileText },
    { to: "/admin/news", label: "الأخبار", icon: Newspaper },
    { to: "/admin/projects", label: "المشاريع", icon: Layers },
    { to: "/admin/downloads", label: "التحميلات", icon: Download },
  ];

  return (
    <div className="min-h-screen bg-paper text-navy" dir="rtl">
      <header className="bg-navy text-white">
        <div className="mx-auto max-w-[1200px] px-6 py-4 flex items-center justify-between">
          <Link to="/admin" className="font-display text-xl">لوحة إدارة سياق</Link>
          <div className="flex items-center gap-4 text-sm">
            <span className="text-white/70 hidden sm:inline">{user.email}</span>
            <button
              onClick={logout}
              data-testid="admin-logout"
              className="inline-flex items-center gap-2 border border-white/30 px-3 py-1.5 hover:bg-white/10 transition-colors"
            >
              <LogOut size={14} /> خروج
            </button>
          </div>
        </div>
        <nav className="mx-auto max-w-[1200px] px-6 flex flex-wrap gap-1 border-t border-white/10">
          {links.map(({ to, label, icon: Icon, exact }) => {
            const active = exact ? location.pathname === to : location.pathname.startsWith(to);
            return (
              <Link
                key={to}
                to={to}
                className={`inline-flex items-center gap-2 px-4 py-3 text-sm transition-colors ${
                  active ? "text-white border-b-2 border-coral" : "text-white/70 hover:text-white"
                }`}
              >
                {Icon && <Icon size={14} />}
                {label}
              </Link>
            );
          })}
        </nav>
      </header>
      <main className="mx-auto max-w-[1200px] px-6 py-10">
        <Outlet />
      </main>
    </div>
  );
}
